export const getWindowWidth = () => {
  const width = window.innerWidth;

  if (width <= 575.98) return 0;
  if (width <= 1200) return 1;
};

export const windowWidth = getWindowWidth();
